import React, { FC, useRef } from 'react';

import classNames from 'classnames';

import Icon from '../icons';

type UploadButtonPropsType = {
  fileAccept?: string;
  onChange?(files: File[]): void;
  loadedFiles: File[];
  label?: string;
  description?: string;
  descriptionPosition?: 'left' | 'right' | 'bottom';
  changeLoadedFiles: React.Dispatch<React.SetStateAction<File[]>>;
  soon?: boolean;
};

const UploadButton: FC<UploadButtonPropsType> = (props) => {
  const {
    fileAccept,
    onChange,
    changeLoadedFiles,
    label,
    description,
    descriptionPosition = 'bottom',
    soon,
  } = props;
  const inputRef = useRef<HTMLInputElement>(null!);

  function handleFiles(files: File[]) {
    onChange?.(files);
  }

  function checkAndRemoveWhitespaces(files: File[]) {
    return files.map((file) => {
      file = new File([file], file.name.replace(/\s/g, ''), { type: file.type });
      return file;
    });
  }

  const handleChange = (inputChangeEvent: React.ChangeEvent<HTMLInputElement>) => {
    inputChangeEvent.preventDefault();
    if (inputChangeEvent.target.files) {
      const file = Object.values(inputChangeEvent.target.files);
      const formattedFiles = checkAndRemoveWhitespaces(file);
      changeLoadedFiles(formattedFiles);
      handleFiles(formattedFiles);
    }
  };

  const onButtonClick = () => {
    inputRef.current?.click();
  };

  const descriptionStyle = classNames('font-[500] text-[12px]  tracking-[-0.03em] text-2color');
  const descriptionLines = description?.split('/n');

  return (
    <div className="w-full" onSubmit={(e) => e.preventDefault()}>
      <input
        ref={inputRef}
        type="file"
        className="hidden"
        onChange={handleChange}
        accept={fileAccept}
      />

      <div
        className={`flex ${
          ['left', 'right'].includes(descriptionPosition) ? 'items-center' : 'flex-col'
        } gap-2`}
      >
        {/* Описание слева */}
        {!soon && description && descriptionPosition === 'left' && (
          <div className={`${descriptionStyle}`}>
            {descriptionLines?.map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index !== descriptionLines.length - 1 && <br />}
              </React.Fragment>
            ))}
          </div>
        )}

        <div className="relative flex flex-col items-center">
          <div
            onClick={onButtonClick}
            className={`py-[8px] px-[12px] border-solid border-[1px] border-b_dark flex items-center w-fit gap-[9px] cursor-pointer rounded-defaultR ${
              soon && 'opacity-50 pointer-events-none'
            }`}
          >
            <Icon size={14} className="text-action" name="DownloadArrowIcon" />
            <span className="font-[500] text-[15px] tracking-[-0.03em] text-2color">
              {label || 'Загрузить файл'}
            </span>
          </div>
          {!soon && description && descriptionPosition === 'bottom' && (
            <div className={`${descriptionStyle} mt-[6px] `}>
              {descriptionLines?.map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index !== descriptionLines.length - 1 && <br />}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
        {soon && (
          <div
            className={`${descriptionStyle} self-start text-[12px] font-medium tracking-[-0.03em] text-2color opacity-50`}
          >
            (Скоро)
          </div>
        )}

        {!soon && description && descriptionPosition === 'right' && (
          <div className={`${descriptionStyle} `}>
            {descriptionLines?.map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index !== descriptionLines.length - 1 && <br />}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadButton;
